module.exports = __webpack_public_path__ + "static/media/demo_5.171afb60.mp4";